import { useMemo } from 'react';
import { useQuoteContext } from '../../../routes/Quotes/Quote/quoteContext';
import {
  deriveQuoteUpliftSummary,
  getUpliftEligibleOfferings,
} from '../../../utils/quoteRenewalUplift.utils';

/**
 * Renewal uplift state for the quote in context.
 *
 * The summary's `isPartial` flag is only meaningful alongside the eligible set
 * it was derived from, so the pair is produced in one place and shared by the
 * header row and the drawer rather than derived independently by each.
 */
export const useQuoteRenewalUplift = () => {
  const {
    quoteData: { quote },
    productOfferingsData: {
      productOfferingsObj,
      loading: isLoadingProductOfferings,
    },
  } = useQuoteContext();

  const eligibleOfferings = useMemo(
    () => (quote ? getUpliftEligibleOfferings(quote, productOfferingsObj) : []),
    [quote, productOfferingsObj],
  );
  const summary = useMemo(
    () =>
      quote
        ? deriveQuoteUpliftSummary(quote, eligibleOfferings)
        : ({ status: 'none', hasLockedConfig: false } as const),
    [quote, eligibleOfferings],
  );

  return { quote, eligibleOfferings, summary, isLoadingProductOfferings };
};
